module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "agent-apply-dialog",
    attrs: {
      "close-on-click-modal": false,
      "modal-append-to-body": false,
      "title": _vm.title,
      "lock-scroll": false,
      "visible": _vm.dialogVisible,
      "custom-class": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [(_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e(), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "经销商类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeAgentType
    },
    model: {
      value: (_vm.form.Industry_Id),
      callback: function($$v) {
        _vm.$set(_vm.form, "Industry_Id", $$v)
      },
      expression: "form.Industry_Id"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 9
    }
  }, [_vm._v("个人")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 14
    }
  }, [_vm._v("公司")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.Industry_Id == 9),
      expression: "form.Industry_Id==9"
    }]
  }, [_c('contact-form', {
    ref: "contactBefore",
    attrs: {
      "value": _vm.contact,
      "isRequired": true,
      "isReadOnly": _vm.isReadOnly && _vm.contactInfoReadOnly
    },
    on: {
      "ProvId": _vm.getProvId,
      "CityId": _vm.getCityId,
      "AreaId": _vm.getAreaId
    }
  })], 1), _vm._v(" "), _c('base-info-form', {
    ref: "baseInfo",
    attrs: {
      "value": _vm.baseInfo,
      "isReadOnly": _vm.isReadOnly && _vm.conpanyInfoReadOnly,
      "isRequired": _vm.isRequired
    },
    on: {
      "showSelectStaffDialog": _vm.showSelectStaffDialog
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.Industry_Id == 14),
      expression: "form.Industry_Id==14"
    }]
  }, [_c('contact-form', {
    ref: "contactAfter",
    attrs: {
      "value": _vm.contact,
      "isRequired": true,
      "isReadOnly": _vm.isReadOnly && _vm.contactInfoReadOnly
    }
  })], 1), _vm._v(" "), _c('h6', {
    staticClass: "ptitle"
  }, [_vm._v("合作信息")]), _vm._v(" "), _vm._l((_vm.agentList), function(agent, index) {
    return _c('agent-info', {
      ref: 'agentInfo' + (index + 1),
      refInFor: true,
      attrs: {
        "isReadOnly": _vm.isReadOnly && _vm.coopInfoReadOnly,
        "value": agent,
        "myIndex": (index + 1),
        "isPerson": _vm.isPerson
      },
      on: {
        "delAgentfn": _vm.delAgentfn
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "agentInfo-add-box"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "icon": "el-icon-plus",
      "type": "success"
    },
    on: {
      "click": _vm.addAgentObj
    }
  }, [_vm._v("+ 添加代理区域")])], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 2), _vm._v(" "), _c('selectStaffDialog', {
    ref: "refSelectStaffDialog",
    on: {
      "selectedStaff": _vm.selectedStaff
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6706ee10!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/apply-dialog/index.vue
// module id = 1509
// module chunks = 1